import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { GlobalVariables } from '../../common/global-variables';
import { ApiService } from '../../services/api/api.service';
import { ToastController } from '@ionic/angular';

@Component({
  selector: 'app-batch-transactions',
  templateUrl: './batch-transactions.page.html',
  styleUrls: ['./batch-transactions.page.scss'],
})
export class BatchTransactionsPage implements OnInit {

  @Input() currentBatch: number;
  @Input() userID: number;
  @Input() AuthToken: string;
  payload: any = {};
  batchTransactions: any = [];

  constructor(private modalCtr: ModalController,  private globals: GlobalVariables, public api: ApiService, public toastController: ToastController) { }

  ngOnInit() {
    this.getGeniGatewayRequest();
  }

  async close() {
    const closeModal: string = "Modal Closed";
    await this.modalCtr.dismiss(closeModal);
  }

  async presentToast(msg, color) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'bottom',
      color
    });
    toast.present();
  }

  async getGeniGatewayRequest() {
    const endpoint = this.globals.deviceInfo.remoteServer + 'GetGeniGatewayRequest';
    debugger;
    this.payload.BatchNo = this.currentBatch;
    this.payload.UserEntityID = this.userID;
    this.payload.AuthToken = this.AuthToken;

    this.api.postApiEndpoint(endpoint, this.payload).subscribe(resp => {
      
        if(resp.ok) 
          this.batchTransactions = resp.data;
        else
          this.presentToast(resp.msg, 'danger');
    });
  }

}
